import React, { useState } from 'react';
import { Button } from '@mui/material';
import ApplyFlowDialogs from '../../components/apply/ApplyFlowDialogs';
import { typeRole } from '../../theme/typeRoles';

/**
 * Reusable Apply Now button.
 * Opens the same two-step modal flow as the navbar's APPLY NOW button
 * (see components/apply/ApplyFlowDialogs).
 *
 * Text follows the /dashboard/typography "Button text" role via the theme;
 * pass `hero` for buttons inside a hero banner to use the "Hero CTA" role.
 */
export default function ApplyFlowButton({
  label = 'APPLY NOW',
  sx = {},
  fullWidth = false,
  size = 'large',
  variant = 'contained',
  hero = false,
  ...buttonProps
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant={variant}
        size={size}
        fullWidth={fullWidth}
        onClick={() => setOpen(true)}
        sx={{
          bgcolor: '#b89b5e',
          color: '#fff',
          ...(hero ? typeRole('hero-cta') : {}),
          borderRadius: 1,
          px: 3,
          py: 0.9375,
          letterSpacing: 0.375,
          '&:hover': { bgcolor: '#ab9767' },
          ...sx,
        }}
        {...buttonProps}
      >
        {label}
      </Button>

      <ApplyFlowDialogs open={open} onClose={() => setOpen(false)} />
    </>
  );
}
